/* eslint-disable consistent-return */
/* eslint-disable no-empty */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CallsActionDataType, ExportParams } from './calls.types';
import { instance } from '../../api/api.config';
import { langSlice } from '../lang/lang.slice';
import { callsActions } from '.';
import { getTokens } from 'utils/tokens';
import { translate } from 'localizations';
import { useParams } from 'react-router-dom';
import { RouteParams } from 'pages/Settings/types';

export const getAllUserDicts = createAsyncThunk('dicts/getAllUserDicts', async () => {
	const { token } = getTokens();
	const { data } = await instance.get(`/dicts/?show_disabled=false&only_local=false`, {
		headers: {
			Authorization: `Bearer ${token}`,
			accept: `application/json`,
		},
	}); // @ts-ignore
	// await thunkAPI.dispatch(callsActions.setAllUserDicts({allUserDicts: data}));
	return data;
});
export const getAllWordInDictionary = createAsyncThunk(
	'dicts/getAllWordInDictionary',
	async (payload: { id: string }) => {
		const { token } = getTokens();
		const { data } = await instance.get(`/dict/${payload.id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
				accept: `application/json`,
			},
		});
		return data;
	},
);
export const updateDict = createAsyncThunk(
	'dicts/updateDictPhrases',
	async (payload: { dictId: string; phrases: any[] }) => {
		try {
			const { token } = getTokens();
			const sendData = { phrases: payload.phrases }; // @ts-ignore
			const response = await instance.put<string>(`/dict/${payload.dictId}`, JSON.stringify(sendData), {
				headers: {
					'Content-Type': 'application/json',
					accept: 'application/json',
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (error) {}
	},
);

export const addPhraseToDict = createAsyncThunk(
	'dicts/addPhraseToDict',
	async (payload: { dictId: string; phrase: any[] }) => {
		const { token } = getTokens();
		const sendData = payload.phrase;
		const response = await instance.post(`/dict/${payload.dictId}/add_phrase`, sendData[sendData.length - 1], {
			headers: {
				'Content-Type': 'application/json',
				accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	},
);

export const getCallPublicToken = createAsyncThunk('calls/getCallPublicToken', async (id: string) => {
	const { token } = getTokens();
	const { data } = await instance.get(`call/${id}/public_token`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	return data;
});

export const getCallStt = createAsyncThunk(
	'calls/getCallStt',
	async (payload: { id: string | any; token?: string | any }, thunkAPI) => {
		try {
			const { token } = getTokens();
			const { data } = await instance.get(`call/${payload.id}/stt`, {
				headers: { Authorization: `Bearer ${payload.token ? payload.token : token}` },
			});
			thunkAPI.dispatch(callsActions.setStt(data));
			return data;
		} catch (e) {
			thunkAPI.dispatch(
				langSlice.actions.setSnackbar({
					type: 'error',
					time: 2000,
					text: 'Что-то пошло не так',
				}),
			);
		}
	},
);

export const getCallAudio = createAsyncThunk(
	'calls/getCallAudio',
	async (payload: { id: string | any; token?: string | any }, thunkAPI) => {
		const { token } = getTokens();
		const { data } = await instance.get(`call/${payload.id}/audio`, {
			responseType: 'arraybuffer',
			headers: {
				Authorization: `Bearer ${payload.token ? payload.token : token}`,
				'Content-Type': 'audio/wav',
			},
		});
		const blob = new Blob([data], { type: 'audio/wav' });
		const blobUrl = URL.createObjectURL(blob);
		return blobUrl;
	},
);

export const getTokenForCallAudio = createAsyncThunk(
	'calls/getTokenForCallAudio',
	async (payload: { id: string | any; token?: string | any }, thunkAPI) => {
		const { token } = getTokens();
		const response = await instance.get(`call/${payload.id}/token_for_audio`, {
			headers: { Authorization: `Bearer ${payload.token ? payload.token : token}` },
		});
		thunkAPI.dispatch(callsActions.setToken(response.data.access_token));
	},
);

export const deleteCall = createAsyncThunk('calls/deleteCall', async (id: string, thunkAPI) => {
	try {
		const { token } = getTokens();
		return await instance.delete(`call/${id}`, { headers: { Authorization: `Bearer ${token}` } });
	} catch (error) {
		thunkAPI.dispatch(
			langSlice.actions.setSnackbar({
				type: 'error',
				time: 2000,
				text: 'Что-то пошло не так',
			}),
		);
	}
});

export const callsAction = createAsyncThunk('calls/callsAction', async (payload: CallsActionDataType, thunkAPI) => {
	try {
		const { token } = getTokens();
		const { data } = await instance.post(`calls/action`, payload, {
			headers: { Authorization: `Bearer ${token}` },
		});
		return data;
	} catch (error: any) {
		thunkAPI.dispatch(
			langSlice.actions.setSnackbar({
				type: 'error',
				time: 2000,
				text: 'Что-то пошло не так',
			}),
		);
		return thunkAPI.rejectWithValue(error);
	}
});

export const getCallMetaInfo = createAsyncThunk('call/getCallInfo', async (call_id: string, thunkAPI) => {
	try {
		thunkAPI.dispatch(callsActions.setMetaInfoIsLoading(true));
		const { token } = getTokens();
		const response = await instance.get(`call/${call_id}/info`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		thunkAPI.dispatch(callsActions.setMetaInfoIsLoading(false));

		return response.data;
	} catch (error) {
		console.log(error);
	}
});

export const getExportParams = createAsyncThunk(
	'calls/getExportParams',
	async (payload: { search_filter_hash: string; call_ids: string[] }, thunkAPI) => {
		try {
			const { token } = getTokens();
			const { data } = await instance.post<ExportParams>(
				`/calls/export_params`,
				{
					search_filter_hash: payload.search_filter_hash,
					call_ids: payload.call_ids,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
						accept: 'application/json',
					},
				},
			);
			return data;
		} catch (error) {
			const { lang } = useParams<RouteParams>();
			thunkAPI.dispatch(
				langSlice.actions.setSnackbar({
					type: 'error',
					time: 2000,
					text: translate('failedToGetTags', lang),
				}),
			);
			throw error;
		}
	},
);

export const getEngineSTT = createAsyncThunk(
	'call/getEngineSTT',
	async (payload: { call_id: string; engine: string }, thunkAPI) => {
		try {
			const { token } = getTokens();
			const response = await instance.get(`call/${payload.call_id}/stt?engine=${payload.engine}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (response.data) {
				thunkAPI.dispatch(callsActions.setStt(response.data));
			}
			return response.data;
		} catch (error) {
			console.log(error);
		}
	},
);
